export default theme => ({
  root: {
    marginTop: '2rem',
  },
  tableRow: {
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
    cursor: 'pointer',
    height: '64px',
  },
  tableCell: {
    whiteSpace: 'nowrap',
  },
  tableCellInner: {
    display: 'flex',
    alignItems: 'center',
  },
  orgModal: {
    color: theme.palette.primary.main,
  },
  menuAction: {
    '&:first-child': {
      display: 'none',
    },
  },
});
